<template>
  <span>
    <router-link :to="'/tasks/resourcegroups/' + id" v-if="userHasReadPermission(PermissionTypes.TaskPermissionTypes.taskConfig)" :target="target" :class="{'router-link-newtab': newTab}">
      {{name}}
    </router-link>
    <span v-else>
      {{name}}
    </span>
  </span>
</template>

<script>
export default {
  name: 'LinkResourceGroup',
  props: {
    id: Number,
    name: String,
    newTab: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    target() {
      if(this.newTab)
        return '_blank'

      return '_self'
    }
  }
}
</script>
